<template>
    <div>
        <div class="d-flex justify-content-center mb-2">
            <div class="property-name">{{ rentalPropertyName }}</div>
        </div>
        <iframe
            :id="calendarId"
            ref="iframe"
            frameborder="0"
            marginheight="0"
            marginwidth="0"
        ></iframe>
    </div>
</template>

<script>
const MIN_SINGLE_CALENDAR_HEIGHT = 650;
const MAX_SINGLE_CALENDAR_WIDTH = 556;

export default {
    name: 'OnlineBookingCalendarSingle',
    props: {
        calendarId: String,
        rentalPropertyId: Number,
        rentalPropertyName: String,
        websiteUrl: String,
        language: String,
    },
    mounted() {
        const iframe = this.$refs.iframe;

        iframe.onload = this.onFrameLoad;
        iframe.style.width = '100%';
        iframe.style.maxWidth = MAX_SINGLE_CALENDAR_WIDTH + 'px';
        iframe.style.height = MIN_SINGLE_CALENDAR_HEIGHT + 'px';
        iframe.src = [
            document.location.origin,
            '/booking-calendar/websites/', this.websiteUrl,
            '/properties/', this.rentalPropertyId,
            '/?iframe=', this.calendarId,
            '&lang=', this.language,
            '&v=', Math.random()
        ].join('');

        window.addEventListener('resize', this.onFrameLoad);
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.onFrameLoad);
    },
    methods: {
        onFrameLoad() {
            this.setBookingCalendarWidth();
        },
        setBookingCalendarWidth() {
            const iframe = this.$refs.iframe;
            // Get available width
            const rect = iframe.parentNode.getBoundingClientRect();
            const newWidth = Math.min(Math.floor(rect.width / 7) * 7, MAX_SINGLE_CALENDAR_WIDTH);
            // Send new width to the iframe
            if (iframe.contentWindow) {
                iframe.contentWindow.postMessage('width=' + newWidth, document.location.origin);
            }
        },
    }
}
</script>

<style lang="sass" scoped>
.property-name {
    font-size: 14px !important;
    font-weight: bold;
}
</style>